<template>
  <a-card :bordered="false">
    <!-- table区域-begin -->
    <div>
      <a-table
        ref="table"
        size="middle"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        @change="handleTableChange">

      </a-table>
    </div>
  </a-card>
</template>

<script>
  // import {JeecgListMixin} from '@/mixins/JeecgListMixin'

  export default {
    props:['userId'],
    name: "UserTab3",
    // mixins: [JeecgListMixin],
    data() {
      return {
        queryParam:{
          userId:this.userId
        },
        description: '我的收益明细',
        visible: false,
        // 表头
        columns: [
          {
            title: '订单编号',
            align: "center",
            dataIndex: 'orderNo'
          },
          {
            title: '用户昵称',
            align: "center",
            dataIndex: 'userId_dictText'
          },
          {
            title: '收支金额（元）',
            align: "center",
            dataIndex: 'changeMoney',
            scopedSlots: {customRender: "changeMoneySlot"}
          },
          {
            title: '资金类型',
            align: "center",
            dataIndex: 'fundType',
            customRender: function (text) {
              if (text == 1) {
                return "余额";
              } else if (text == 2) {
                return "冻结";
              } else {
                return "未知";
              }
            }
          },
          {
            title: '订单标题',
            align: "center",
            dataIndex: 'title'
          },
          {
            title: '出/入账时间',
            align: "center",
            dataIndex: 'createTime'
          }
        ],
        url: {
          list: "/user/userExtension/getIncomeDetails",
        },
      }
    },
    computed: {
    },
    methods: {
    },
  }
</script>